module.exports = __webpack_public_path__ + "static/media/hab7-0.dc80ec98.jpg";